<template>
    <dl class="ck-informations">
        <dt v-html="label"></dt>
        <dd v-if="display" v-html="display"></dd>
        <dd v-else><slot></slot></dd>
    </dl>
</template>

<script>
import Vue from 'vue';
export default Vue.component('ck-informations', {
    props: {
        display: {
            default: ''
        },
        label: {
            default: ''
        }
    },
    methods: {
    },

    watch: {
    }
});
</script>

<style>
    .ck-informations dt {
        margin-bottom: 2px;
    }
    .ck-informations dd {
        margin-left: 0px;
        min-height: 20px;
    }
    .ck-informations {
        background: #f9f9f9;
        padding: 10px 15px;
        border-radius: 4px;
        margin: 0;
        margin-bottom: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/visual/ck-informations.vue